export default __webpack_public_path__ + "static/media/get-more-blog.be6b22ce.jpg";